import React from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import styles from './Thermometer.module.css'

interface ThermometerProps {
  title: string
  good: number
  regular: number
  bad: number
  notCompletedCount?: number
  showRegular?: boolean
  labels?: {
    good?: string
    regular?: string
    bad?: string
  }
}

export const Thermometer = ({
  title,
  good,
  regular,
  bad,
  notCompletedCount = 0,
  showRegular = true,
  labels = {},
}: ThermometerProps) => {
  const { t } = useTranslation()

  const {
    good: goodLabel = t('good'),
    regular: regularLabel = t('regular'),
    bad: badLabel = t('bad'),
  } = labels

  return (
    <Box className={styles.thermometerContainer}>
      <Box className={styles.thermometerContent}>
        <Typography variant="h6" className={styles.title}>
          {title}
        </Typography>

        <Box className={styles.thermometer}>
          {bad > 0 && (
            <Box
              className={styles.segment}
              style={{
                height: `${bad}%`,
                backgroundColor: '#EC6D62',
                bottom: '0',
              }}
            />
          )}

          {showRegular && regular > 0 && (
            <Box
              className={styles.segment}
              style={{
                height: `${regular}%`,
                backgroundColor: '#F5C451',
                bottom: `${bad}%`,
              }}
            />
          )}

          {good > 0 && (
            <Box
              className={styles.segment}
              style={{
                height: `${good}%`,
                backgroundColor: '#ABD47B',
                bottom: `${bad + (showRegular ? regular : 0)}%`,
              }}
            />
          )}
        </Box>
      </Box>

      <Box className={styles.legend}>
        <Typography variant="body2" className={styles.legendItem}>
          {goodLabel}: {good.toFixed(0)}%
        </Typography>
        {showRegular && (
          <Typography variant="body2" className={styles.legendItem}>
            {regularLabel}: {regular.toFixed(0)}%
          </Typography>
        )}
        <Typography variant="body2" className={styles.legendItem}>
          {badLabel}: {bad.toFixed(0)}%
        </Typography>
        {notCompletedCount > 0 && (
          <Typography
            variant="body2"
            className={styles.legendItem}
            style={{ color: '#666', fontStyle: 'italic' }}
          >
            {notCompletedCount} {t('notComplete')}
          </Typography>
        )}
      </Box>
    </Box>
  )
}
